/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { FaEdit } from "react-icons/fa";
import { MdDeleteSweep } from "react-icons/md";
import { Flex, Heading, Button } from "@chakra-ui/react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import FormInput from "../../../components/forms/form-Input";
import { contactPersonDefault } from "../constants";

export default function ContactPerson({
  onNextStep,
  onPrevStep,
  contactPersons,
  addData,
}) {
  const [currentEditing, setCurrentEditing] = useState(null);

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: contactPersons
      ? { ...contactPersonDefault, contactPersons: [...contactPersons] }
      : { ...contactPersonDefault },
  });
  const generalFieldProps = { control, errors };
  const formValidationRules = {
    firstName: { required: "Please enter first name" },
    lastName: { required: "Please enter last name" },
    email: {
      required: "Please add email",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Invalid email(abc@gmail.com)",
      },
    },
    mobileNo: {
      required: "Please add mobile number",
      validate: (value) => {
        if (value && value.length < 9) return "Please add valid mobile number";
        return true;
      },
    },
    personalMobileNo: {
      validate: (value) => {
        if (value && value.length < 9) return "Please add valid mobile number";
        return true;
      },
    },
    officeNo: {
      validate: (value) => {
        if (value && value.length < 9) return "Please add valid contact Number";
        return true;
      },
    },
    designation: { required: "Please add designation" },
  };
  const { fields: contactPersonFields, remove: contactPersonRemove } =
    useFieldArray({
      control: generalFieldProps.control,
      name: "contactPersons",
    });

  useEffect(() => {
    if (addData) {
      addData([...contactPersonFields]);
    }
  }, [contactPersonFields]);

  const submitInfo = (data) => {
    const _data = { ...data };
    const _fields = [...contactPersonFields];
    const contactPersonObj = {
      firstName: _data.firstName,
      lastName: _data.lastName,
      mobileNo: _data.mobileNo,
      email: _data.email,
      personalMobileNo: _data.personalMobileNo,
      officeNo: _data.officeNo,
      designation: _data.designation,
    };

    if (currentEditing !== null) {
      _fields[currentEditing] = { ...contactPersonObj };
      setCurrentEditing(null);
    } else {
      _fields.push({ ...contactPersonObj });
    }
    reset({ ...contactPersonDefault, contactPersons: _fields });
  };

  const cancelEditing = () => {
    setCurrentEditing(null);
    const _fields = [...contactPersonFields];
    reset({ ...contactPersonDefault, contactPersons: _fields });
  };

  const editCell = ({ dataItem, dataIndex }) => {
    return (
      <td>
        <Flex
          title="Edit Contact Person"
          cursor="pointer"
          onClick={() => {
            reset({
              ...contactPersonDefault,
              ...dataItem,
              contactPersons: [...contactPersonFields],
            });
            setCurrentEditing(dataIndex);
          }}
        >
          <FaEdit fontSize="18px" color="var(--primary-dark)" />
        </Flex>
      </td>
    );
  };

  const deleteCell = ({ dataIndex }) => {
    return (
      <td>
        <Flex
          title="Delete Contact Person"
          cursor="pointer"
          onClick={() => {
            contactPersonRemove(dataIndex);
          }}
        >
          <MdDeleteSweep fontSize="18px" color="red" />
        </Flex>
      </td>
    );
  };

  return (
    <form onSubmit={handleSubmit(submitInfo)}>
      <Flex w="100%" justify="space-between" flexDirection="row">
        <Heading style={{ width: "100%" }}>Contact Person</Heading>
        <Flex w="100%" justify="flex-end" flexDirection="row">
          <Flex w="100%" justify="flex-end" flexDirection="row" gap="16px">
            <Button
              button="button"
              onClick={() => onPrevStep([...contactPersonFields])}
            >
              Back
            </Button>
            <Button
              button="button"
              onClick={() => onNextStep([...contactPersonFields])}
            >
              Next
            </Button>
          </Flex>
        </Flex>
      </Flex>

      <FormInput
        {...generalFieldProps}
        isRequired
        label="First Name"
        rules={formValidationRules.firstName}
        name="firstName"
      />
      <FormInput
        {...generalFieldProps}
        isRequired
        label="Last Name"
        rules={formValidationRules.lastName}
        name="lastName"
      />
      <FormInput
        {...generalFieldProps}
        isRequired
        label="Email"
        name="email"
        rules={formValidationRules.email}
        info="abc@xyz.com"
      />
      <FormInput
        {...generalFieldProps}
        isRequired
        label="Mobile No"
        name="mobileNo"
        rules={formValidationRules.mobileNo}
        info="Minimum Length 10"
      />
      <FormInput
        {...generalFieldProps}
        label="Personal Mobile No"
        name="personalMobileNo"
        rules={formValidationRules.personalMobileNo}
        info="Minimum Length 10"
      />
      <FormInput
        {...generalFieldProps}
        label="Business Contact Number"
        name="officeNo"
        rules={formValidationRules.officeNo}
      />

      <FormInput
        {...generalFieldProps}
        isRequired
        label="Designation"
        name="designation"
        rules={formValidationRules.designation}
      />

      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          gap: "16px",
        }}
      >
        {currentEditing !== null ? (
          <Button type="button" onClick={cancelEditing}>
            Cancel
          </Button>
        ) : (
          <></>
        )}
        <Button type="submit">
          {currentEditing !== null ? "Update" : "Add"}
        </Button>
      </div>

      <Grid data={contactPersonFields}>
        <GridColumn field="firstName" title="First Name" />
        <GridColumn field="lastName" title="Last Name" />
        <GridColumn field="email" title="Email" />
        <GridColumn field="mobileNo" title="Mobile No" />
        <GridColumn field="personalMobileNo" title="Personal Mobile No" />
        <GridColumn field="officeNo" title="Office No" />
        <GridColumn field="designation" title="Designation" />
        <GridColumn title="Edit" width="80" cell={editCell} />
        <GridColumn title="Delete" width="80" cell={deleteCell} />
      </Grid>
    </form>
  );
}
